(function () {
  'use strict';

  if (window.matchMedia('(pointer: coarse)').matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var dot = document.createElement('span');
  var ring = document.createElement('span');
  dot.className = 'blx-cursor-dot';
  ring.className = 'blx-cursor-ring';
  dot.setAttribute('aria-hidden', 'true');
  ring.setAttribute('aria-hidden', 'true');
  document.body.appendChild(dot);
  document.body.appendChild(ring);
  document.documentElement.classList.add('has-custom-cursor');

  var ringX = 0;
  var ringY = 0;
  var targetX = 0;
  var targetY = 0;

  document.addEventListener('pointermove', function (event) {
    targetX = event.clientX;
    targetY = event.clientY;
    dot.style.transform = 'translate3d(' + targetX + 'px,' + targetY + 'px,0)';
  });

  document.addEventListener('pointerover', function (event) {
    if (event.target.closest('a, button, input, select, textarea, summary')) ring.classList.add('is-hovering');
  });
  document.addEventListener('pointerout', function (event) {
    if (event.target.closest('a, button, input, select, textarea, summary')) ring.classList.remove('is-hovering');
  });

  function render() {
    ringX += (targetX - ringX) * 0.16;
    ringY += (targetY - ringY) * 0.16;
    ring.style.transform = 'translate3d(' + ringX + 'px,' + ringY + 'px,0)';
    requestAnimationFrame(render);
  }
  render();
})();
